import React from 'react';
import { Link } from 'react-router-dom';
import { Content, Icon, Button, ButtonToolbar, ButtonGroup } from 'rsuite';
import * as PERMISSIONS from '../../../constants/permissions/outreach';
import { viewAccess, modifyAccess } from '../../../helpers/permission';
import AccessControl from '../../../components/AccessControl';
import AccessDenied from '../../../components/AccessDenied';
import PageHeader from '../../../components/PageHeader';
import PageLayout from '../../../components/Outreach/PageLayout';
import OutreachSearch from '../../../containers/Outreach/Search/Outreach';
import OutreachList from '../../../containers/Outreach/OutreachList';
import { outreachCreatePath } from '../../Paths';

export default () => (
  <PageLayout>
    <AccessControl
      allowOnlyFor={viewAccess(PERMISSIONS.OUTREACH)}
      fallback={<AccessDenied />}
    >
      <PageHeader title="Outreaches">
        <ButtonToolbar>
          <ButtonGroup style={{ float: 'right' }}>
            <AccessControl allowOnlyFor={modifyAccess(PERMISSIONS.OUTREACH)}>
              <Link to={outreachCreatePath}>
                <Button appearance="primary">
                  <Icon icon="plus-circle" /> Create New
                </Button>
              </Link>
            </AccessControl>
          </ButtonGroup>
          <OutreachSearch placeholder="Type outreach and press enter" />
        </ButtonToolbar>
      </PageHeader>
      <Content>
        <OutreachList />
      </Content>
    </AccessControl>
  </PageLayout>
);
